import React from "react";
import { isEmpty } from "lodash";
import { useCustomerChildrenList_GetQuery } from "@graphql";
import { Spinner } from "@components";
import locale from "@bonliva-crm/locale";
import { CustomerChildrenList } from "./CustomerChildrenList";

type Props = {
  filterGroups?: (group: string) => boolean;
  id: string;
  onAddContactPerson: (group: string | null) => void;
  onAddCustomer: (group: string | null) => void;
  onClick: (customerId: string) => void;
  onGroupHeaderClick: (group: string | null) => void;
  renderGroup: (group: React.ReactNode, groupName: string) => React.ReactNode;
  title: string;
};

export function CustomerChildren(props: Props) {
  const { id, filterGroups = () => true, renderGroup = (x) => x } = props;

  const { data, loading, error } = useCustomerChildrenList_GetQuery({
    variables: { id }
  });

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <div>{error.toString()}</div>;
  }

  const { customerById: item } = data;

  const allSubgroups = item.DirectChildrenFull.flatMap((x) => x.CustomerGroups)
    .unique()
    .sortBy((x) => x)
    .concat("__other__")
    .filter(filterGroups);

  return (
    <>
      {allSubgroups.map((_group) => {
        const group = _group !== "__other__" ? _group : null;

        const children = item.DirectChildrenFull.filter((x) =>
          group ? x.CustomerGroups.includes(group) : isEmpty(x.CustomerGroups)
        );

        return renderGroup(
          <CustomerChildrenList
            key={_group}
            canAdd
            items={children}
            expanded={allSubgroups.length === 1 || !group}
            noScrollbar={allSubgroups.length === 1}
            title={group || locale.OtherCustomers}
            onAddCustomer={() => props.onAddCustomer(group)}
            onAddContactPerson={() => props.onAddContactPerson(group)}
            onClick={props.onClick}
            onHeaderClick={() => {
              localStorage.expandedGroup = group;
              props.onGroupHeaderClick(group);
            }}
          />,
          _group
        );
      })}
    </>
  );
}
